import { ColDef } from 'ag-grid-community';

export class XpanseCallCenterClientGridColumnsModel {
	/**
	 * Return columns configuration
	 */
	getColumns(): Array<ColDef> {
		return [
			{
				headerName: 'Branch Id',
				field: 'defaultBranchId',
				width: 120,
				resizable: true
			},
			{
				headerName: 'Branch Name',
				field:'defaultBranchName',
				width: 120
			},
			{
				headerName: 'Client Id',
				field:'defaultClientId',
				width: 120
			},
            {
				headerName: 'Client Name',
				field:'defaultClientName',
				width: 120
			},
            {
				headerName: 'AppScope User',
				field:'defaultAppScopeUserCreation',
				width: 120
			},
            {
				headerName: 'Xpanse client id',
				field:'xpanseClientId',
				width: 120
			},
			{
				headerName: 'Actions',
				width: 50,
				resizable: true,
				cellRenderer: 'customActionCallCenterXpanseCellComponent'
			}
		];
	}
}
